module.exports = __webpack_public_path__ + "img/2.463c2cc.png";